import PropTypes from "prop-types";
import React from "react";

import SVGIcon from "~components/utils/svg_icon/svg_icon";

import { leadingIconStyle } from "./input_leading_icon.module.scss";

export default function InputLeadingIcon({ icon, iconSize }) {
  return (
    <div className={leadingIconStyle}>
      <SVGIcon
        icon={icon}
        width={iconSize}
        height={iconSize}
        color="cloudBurst50"
      />
    </div>
  );
}

InputLeadingIcon.propTypes = {
  icon: PropTypes.string,
  iconSize: PropTypes.number,
};

InputLeadingIcon.defaultProps = {
  icon: "",
  iconSize: 20,
};
